import { Col, Container, Row } from 'reactstrap';
import styled from 'styled-components';

const AppPage = styled('div')`
  padding: 0 2rem;
  margin-bottom: 3.5rem;
`;

const PrivacyPage = (): JSX.Element => {
  return (
    <Container fluid={true}>
      <Row>
        <Col xs={12}>
          <h1 style={{ margin: '5px auto', width: 'fit-content' }}>PRM Online Privacy Policy</h1>
        </Col>
        <Col xs={12}>
          <AppPage style={{ marginTop: '2rem' }}>
            <p>
              Your privacy is important to us. We respect your privacy and comply with any applicable law and regulation regarding any information we
              may collect about you, including across our website, https://prmonline.ca/, and other sites we own and operate. PRM Online does not
              share any user data with third parties. All data collected is used solely to provide and improve the functionality of our application
              and services. As such, no data may be collected on this site other than to support that purpose.
            </p>
            <h3>Google Cloud Platform and Services</h3>
            <p>This web application uses the following functionalities:</p>
            <h4>Google Oauth2 Functionality</h4>
            <p>Google User Account data is used for login and authentication purposes only and will not be collected for any other use.</p>
            <h4>Google Sheet Functionality</h4>
            <p>Google Sheet integrations has the following functionality:</p>
            <ul>
              <li>Create empty Google Sheet with the owner as the user</li>
            </ul>
            <p>
              This web application will not collect any external data inside the user's Google Sheet. API access to the user's Google Sheet will be
              limited to exporting data for use with in the Google Sheet.
            </p>
            <h3>Information We Collect</h3>
            <p>
              Information we may collect includes both <b>a)</b> information you knowingly and actively provide us, and <b>b)</b> any information
              automatically sent by your devices in the course of accessing our products and services.
            </p>
            <h3>Log Data</h3>
            <p>
              When you visit our website, our servers may automatically log the standard data provided by your web browser.This data may include: your
              browser type and version, the pages you visit, the time and date of your visit, the time spent on each page, other details about your
              visit, and technical details that occur in conjunction with any errors you may encounter.
            </p>
            <h3>Collection and Use of Information</h3>
            <p>
              We do not collect personal information from you. Any data collected is used solely to provide and improve the functionality of our
              application and services. We do not use Google user data for any other purposes beyond those explicitly required for the operation of
              our services.
            </p>
            <h3>Security of Your Personal Information</h3>
            <p>
              When we might process personal information, we will protect it within commercially acceptable means to prevent loss and theft, as well
              as unauthorized access, disclosure, copying, use, or modification.
            </p>
            <p>
              Although we will do our best to protect the information you provide to us, we advise that no method of electronic transmission or
              storage is 100% secure, and no one can guarantee absolute data security. We will comply with laws applicable to us in respect of any
              data breach.
            </p>
            <p>
              You are responsible for using the Google Oauth2 functionality properly, ensuring the security of your own information within the bounds
              of our services.
            </p>
            <h3>How Long We Keep Your Information</h3>
            <p>
              We might collect and keep information only for as long as we need to. This time period may depend on what we are using the information
              for, in accordance with this privacy policy. All collected information will be deleted once it’s no longer required.
            </p>
            <h3>International Transfers of Information</h3>
            <p>
              The information we collect is stored and/or processed in accordance with our partner specifications. Please be aware that the locations
              to which we store, process, or transfer your information may not have the same data protection laws as the country in which you
              initially provided the information.
            </p>
            <ol type="I">
              <li>we will perform those transfers in accordance with the requirements of applicable law; and</li>
              <li>we will protect the transferred information in accordance with this privacy policy.</li>
            </ol>
            <h3>Your Rights and Controlling Your Information</h3>
            <p>
              You always retain the right to withhold information from us, with the understanding that your experience of our website may be affected.
              We will not discriminate against you for exercising any of your rights over your information. If you do provide us with information you
              understand that we will collect, hold, use and disclose it in accordance with this privacy policy. Partners retain the right to request
              details of any information we hold.
            </p>
            <p>
              If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant, or misleading, please contact
              us using the details provided in this privacy policy. We will take reasonable steps to correct any information found to be inaccurate,
              incomplete, misleading, or out of date.
            </p>
            <p>
              If you believe that we have breached a relevant data protection law and wish to make a complaint, please contact us using the details
              below and provide us with full details of the alleged breach. We will promptly investigate your complaint and respond to you, in
              writing, setting out the outcome of our investigation and the steps we will take to deal with your complaint. You also have the right to
              contact a regulatory body or data protection authority in relation to your complaint.
            </p>
            <h3>Limits of Our Policy</h3>
            <p>Our website is not linked to external sites that are not operated by us and follows a constant standard.</p>
            <h3>Changes to This Policy</h3>
            <p>
              At our discretion, we may change our privacy policy to reflect updates to our business processes, current acceptable practices, or
              legislative or regulatory changes. If we decide to change this privacy policy, we will post the changes here at the same link by which
              you are accessing this privacy policy.
            </p>
            <p>
              If required by law, we will get your permission or give you the opportunity to opt in to or opt out of, as applicable, any new uses of
              your personal information.
            </p>
            <h3>Contact Us</h3>
            <p>For any questions or concerns regarding this policy, please contact:-</p>
            <p>contact@stacktics.com</p>
          </AppPage>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPage;
